import { KeyboardEvent } from "react";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useSYS4010_R01Store } from "src/containers/mes/SYS/SYS4010_R01/Store_SYS4010_R01";

// Props 타입 정의: 사업장명, 변경 핸들러, 엔터키 핸들러
interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

// 사업장 검색 영역 컴포넌트
export const SearchSection_SYS4010_R01 = ({ onEnterKeyDown }: Props) => {

	const { SYS4010_R01Filter, setSYS4010_R01Filter } = useSYS4010_R01Store();

	return (
		<SearchSectionForm>
				{/* 사업장명 입력란 */}
				<SearchInputForm
					label="사업장명-상호명"
					value={SYS4010_R01Filter.compNm}
					onChange={(e) => setSYS4010_R01Filter({ compNm: e.target.value})}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							onEnterKeyDown(e);
						}
					}}
					initValue={() => setSYS4010_R01Filter({ compNm: ''})}
				/>
		</SearchSectionForm>
	)

}